import React, {useEffect, useState} from "react";
import axios from "axios";
import ListDataKategoriDataCompOpenData from "../../../components/open_data/kategori/ListDataKategoriDataCompOpenData";
import SearchKategoriDataCompOpenData from "../../../components/open_data/kategori/SearchKategoriDataCompOpenData";
import "../../../config";

const ListDataKategoriDataOpenData = ({formatDate}) => {
    const [data_x, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const itemsPerPage = 12;

    const api1Url = global.config.host + '/api/3/action/group_list';
    const api2Url = global.config.host + '/api/3/action/group_show?id=';

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response1 = await axios.get(api1Url);
                const ids = response1.data.result;

                const api2Requests = ids.map(id => axios.get(`${api2Url}${id}`));
                const api2Responses = await Promise.all(api2Requests);
                const api2Data = api2Responses.map(res => res.data.result);

                setData(api2Data);
                setFilteredData(api2Data); // Set filtered data to all data initially
                setTotalItems(api2Data.length); // Set total items to the length of all data
            } catch (error) {
                console.error('Error fetching data', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        // Filter data setiap kali searchQuery berubah
        filterData();
    }, [searchQuery, data_x]);

    const filterData = () => {
        let filtered = data_x;

        if (searchQuery) {
            filtered = data_x.filter(item =>
                item.title.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        setFilteredData(filtered);
        setTotalItems(filtered.length); // Update total items to filtered data length
    };

    const handleSearch = (query) => {
        setSearchQuery(query);
        setCurrentPage(1); // Reset halaman ke 1 saat pencarian berubah
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const startItem = indexOfFirstItem + 1;
    const endItem = Math.min(indexOfLastItem, totalItems);

    const totalPages = Math.ceil(totalItems / itemsPerPage);

    return (
        <div>
            <SearchKategoriDataCompOpenData onSearch={handleSearch} />
            <ListDataKategoriDataCompOpenData
                items={currentData}
                // currentPage={currentPage}
                totalItems={totalItems}
               /*  itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange} */
                formatDate={formatDate}
                /* startItem={startItem}
                endItem={endItem} */
                loading={loading}
                // totalPages={totalPages}
            />
        </div>
    );
};

export default ListDataKategoriDataOpenData;